import React from 'react';
import Icon from '../../../components/AppIcon';

const ViewRecruiterModal = ({ isOpen, onClose, recruiter }) => {
  if (!isOpen || !recruiter) return null;

  const details = [
    { label: 'Agency Name', value: recruiter.name },
    { label: 'FWCMS Registered Name', value: recruiter.fwcms_registered_name },
    { label: 'Address', value: recruiter.address },
    { label: 'Source Country', value: recruiter.country },
    { label: 'Representative Name', value: recruiter.representative_name },
    { label: 'Contact Number', value: recruiter.contact_no },
    { label: 'Point of Entry', value: recruiter.point_of_entry },
    { label: 'Embassy at Source Country', value: recruiter.embassy },
    { label: 'Registered On', value: new Date(recruiter.created_at).toLocaleDateString() },
  ];

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col">
        <div className="flex items-center justify-between p-5 border-b border-gray-200">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Recruiter Profile</h2>
            <p className="text-sm text-gray-500">Details for {recruiter.name}</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors">
            <Icon name="X" size={20} className="text-gray-500" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-6">
          <div className="space-y-4">
            {details.map(detail => (
              <div key={detail.label} className="grid grid-cols-3 gap-4 items-start">
                <dt className="text-sm font-medium text-gray-500 col-span-1">{detail.label}</dt>
                <dd className="text-sm text-gray-900 col-span-2">{detail.value || 'N/A'}</dd>
              </div>
            ))}
          </div>
        </div>
        <div className="p-4 bg-gray-50 border-t border-gray-200 flex justify-end">
            <button
                onClick={onClose}
                className="px-4 py-2 bg-gray-600 text-white rounded-md text-sm font-medium hover:bg-gray-700"
            >
                Close
            </button>
        </div>
      </div>
    </div>
  );
};

export default ViewRecruiterModal; 